export const PLACEHOLDER_LABELS: Record<string, string> = {
  client_first_name: 'Client first name',
  client_name: 'Client name',
  advisor_first_name: 'Advisor first name',
  advisor_last_name: 'Advisor last name',
  event_type_name: 'Event type',
  old_event_type_name: 'Old event type',
  duration: 'Duration',
  old_duration: 'Old duration',
  location: 'Location',
  old_location: 'Old location',
  firm_name: 'Firm name',
  booking_link: 'Booking link',
  end_time: 'End time',
  cancellation_reason: 'Cancellation reason',
  unsubscribe_link: 'Unsubscribe link',
  booking_unsubscribe_link: 'Stop reminders link',
}

const PLACEHOLDER_PATTERN = /{{\s*([\w.]+)\s*}}/g
const STATEMENT_TAG_PATTERN = /{%-?[\s\S]*?-?%}/g
const ATTRIBUTE_PLACEHOLDER_PATTERN = /=("|')(?:(?!\1).)*{{\s*[\w.]+\s*}}(?:(?!\1).)*\1/g
const SCRIPT_TAG_PATTERN = /<script\b[^>]*>[\s\S]*?<\/script\s*>/gi
const EVENT_HANDLER_ATTRIBUTE_PATTERN = /\s+on[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'>]+)/gi
const DANGEROUS_SCHEME_ATTRIBUTE_PATTERN = /([\w-]+)\s*=\s*("|')\s*(?:javascript|data):[\s\S]*?\2/gi
const HREF_ATTRIBUTE_PATTERN = /\bhref\s*=\s*(?:("|')(?:(?!\1)[\s\S])*\1|[^\s"'>]+)/gi

export interface TemplateToken {
  type: 'text' | 'chip'
  value: string
}

export const placeholderLabel = (variable: string): string => {
  const known = PLACEHOLDER_LABELS[variable]
  if (known != null) {
    return known
  }
  const humanized = variable.replace(/[_.]+/g, ' ').trim()
  return humanized.charAt(0).toUpperCase() + humanized.slice(1)
}

export const tokenizeTemplateText = (text: string): TemplateToken[] => {
  const cleaned = text.replace(STATEMENT_TAG_PATTERN, '')
  const tokens: TemplateToken[] = []
  let lastIndex = 0
  for (const match of cleaned.matchAll(PLACEHOLDER_PATTERN)) {
    const index = match.index ?? 0
    if (index > lastIndex) {
      tokens.push({ type: 'text', value: cleaned.slice(lastIndex, index) })
    }
    tokens.push({ type: 'chip', value: placeholderLabel(match[1]) })
    lastIndex = index + match[0].length
  }
  if (lastIndex < cleaned.length) {
    tokens.push({ type: 'text', value: cleaned.slice(lastIndex) })
  }
  return tokens
}

export const transformTemplateBodyHtml = (body: string, chipClassName: string): string =>
  body
    .replace(STATEMENT_TAG_PATTERN, '')
    .replace(SCRIPT_TAG_PATTERN, '')
    .replace(EVENT_HANDLER_ATTRIBUTE_PATTERN, '')
    .replace(DANGEROUS_SCHEME_ATTRIBUTE_PATTERN, (_, name: string) => `${name}="#"`)
    .replace(ATTRIBUTE_PLACEHOLDER_PATTERN, '="#"')
    .replace(HREF_ATTRIBUTE_PATTERN, 'href="#"')
    .replace(PLACEHOLDER_PATTERN, (_, variable: string) => `<span class="${chipClassName}">${placeholderLabel(variable)}</span>`)
